import React, { forwardRef } from "react";
import { useConfig } from "../_util/config-context";

export interface BackDropProps {
  zIndex?: React.CSSProperties["zIndex"];
  style?: React.CSSProperties;
}

export const BackDrop = forwardRef(
  ({ zIndex, style = {} }: BackDropProps, ref: React.Ref<HTMLDivElement>) => {
    const { classPrefix } = useConfig();
    return (
      <div
        ref={ref}
        className={`${classPrefix}-backdrop`}
        style={{ zIndex, ...style }}
      />
    );
  }
);
